export const translations = {
  pt: {
    nav: {
      home: "Home",
      terminal: "O Terminal",
      operations: "Operações",
      infrastructure: "Infraestrutura",
      cabotage: "Cabotagem",
      group: "Grupo",
      contact: "Contato",
      cta: "Fale com a OPS",
    },
    home: {
      heroChip: "TUP OPEN PORT • SÃO LUÍS / MA • BAÍA DE SÃO MARCOS",
      heroTitleA: "Operação Portuária",
      heroTitleB: "Integrada e Estratégica.",
      heroSub:
        "A Open Port Services apresenta o TUP Open Port, um Terminal de Uso Privado estrategicamente posicionado em São Luís, com vocação para granéis, transbordo de carga, apoio logístico, bunker, abastecimento marítimo e cabotagem de contêineres.",
      heroSingular:
        "Um terminal singular em sua região. Estratégico por localização. Diferenciado por vocação operacional.",
      ctaTerminal: "Conheça o Terminal",
      ctaOperations: "Explore as Operações",
      heroCardTag: "Localização Estratégica",
      heroCardText: "Posição privilegiada na Baía de São Marcos, em São Luís/MA.",
      heroBtn: "Solicitar Apresentação",
      marquee: [
        "Granéis & Minerais",
        "Lithothamnium em parceria com a BMO",
        "Transbordo de Carga STS",
        "Cabotagem São Luís – Pecém",
        "Bunker & Abastecimento",
        "Apoio Logístico",
      ],
      locTag: "Localização",
      locTitle: "Localização estratégica na Baía de São Marcos",
      locText:
        "Inserido em uma região de elevada relevância marítima e logística, o TUP Open Port reúne localização privilegiada, acesso estratégico e condições favoráveis para o desenvolvimento de operações portuárias, apoio marítimo e integração regional.",
      locCapState: "Maranhão — inserção regional",
      locCapSat: "Posição do terminal — vista aérea",
      locCapBay: "Baía de São Marcos — canal de acesso e fundeadouros",
      diffTag: "Diferenciais",
      diffTitle: "Um terminal diferenciado em sua região",
      diffText:
        "O TUP Open Port é um dos empreendimentos portuários mais estratégicos de sua área de influência, com perfil singular pela combinação das atividades que reúne.",
      diffItems: [
        "Localização estratégica",
        "Infraestrutura portuária privada",
        "Granéis",
        "Transbordo de carga",
        "Apoio logístico",
        "Bunker / Abastecimento",
        "Cabotagem de contêineres",
        "Integração com novas cadeias regionais",
      ],
      opsTag: "Capacidades",
      opsTitle: "Pilares Operacionais OPS",
      opsText: "Estrutura técnica para atender armadores internacionais e cadeias produtivas.",
      learnMore: "Saiba mais",
      opsCards: [
        {
          tag: "01 • Granéis",
          title: "Granéis",
          desc: "Movimentação de granéis sólidos, com destaque para a operação de Lithothamnium em parceria com a BMO.",
        },
        {
          tag: "02 • Manobras Náuticas",
          title: "Transbordo de Carga (STS)",
          desc: "Operações de transbordo entre navios com suporte técnico e monitoramento contínuo.",
        },
        {
          tag: "03 • Integração",
          title: "Apoio Logístico",
          desc: "Apoio portuário, integração e suporte operacional para cadeias regionais.",
        },
        {
          tag: "04 • Suprimento",
          title: "Bunker e Ponto de Abastecimento",
          desc: "Abastecimento de combustíveis marítimos e suprimentos operacionais.",
        },
        {
          tag: "05 • Cabotagem",
          title: "Cabotagem de Contêineres",
          desc: "Conexão São Luís – Pecém ampliando alternativas logísticas regionais.",
        },
        {
          tag: "06 • Ativo Portuário",
          title: "Infraestrutura Portuária",
          desc: "Terminal de Uso Privado preparado para múltiplas frentes operacionais.",
        },
      ],
      bmoTag: "Frente Estratégica em Granéis",
      bmoTitle: "Granéis com destaque para Lithothamnium",
      bmoText:
        "Dentro de sua vocação para granéis, o TUP Open Port destaca operações relacionadas ao Lithothamnium com a BMO, reforçando sua capacidade de atender cadeias logísticas especializadas e demandas de grande relevância operacional.",
      bmoBoxTitle: "Parceria Operacional BMO",
      bmoBoxText:
        "Capacidade de atender cadeias logísticas especializadas e demandas de grande relevância operacional, conectando granéis, escala e logística marítima.",
      bmoBadge: "Lithothamnium & BMO • TUP Open Port",
      cabTag: "Cabotagem",
      cabTitle: "São Luís – Pecém",
      cabText:
        "O TUP Open Port também se posiciona para a cabotagem de contêineres, com destaque para a conexão São Luís – Pecém, ampliando alternativas logísticas regionais e fortalecendo a integração entre mercados.",
      cabBtn: "Conheça a rota",
      bunkTag: "Apoio Marítimo",
      bunkTitle: "Bunker e Abastecimento",
      bunkText:
        "Soluções de apoio marítimo e abastecimento integram a proposta operacional do TUP Open Port, reforçando seu posicionamento como plataforma portuária e logística de múltiplas frentes.",
      bunkBtn: "Saiba mais",
      ctaTitle: "Sua operação pode começar aqui",
      ctaText:
        "Conheça uma nova plataforma portuária privada no Maranhão, estruturada para integrar cargas, operações marítimas, apoio logístico e novas oportunidades regionais.",
      ctaBtn1: "Fale com a OPS",
      ctaBtn2: "Solicite uma apresentação",
    },
    terminal: {
      chip: "O TERMINAL",
      title: "TUP Open Port",
      sub: "Um Terminal de Uso Privado estrategicamente posicionado em São Luís, Maranhão, com inserção privilegiada na Baía de São Marcos.",
      keyMessage:
        "A localização do TUP Open Port é um de seus principais ativos estratégicos.",
      sec1Tag: "Posição",
      sec1Title: "Posição estratégica em São Luís",
      sec1Text:
        "A localização do TUP Open Port é um de seus principais ativos estratégicos, favorecendo operações marítimas, apoio logístico e integração com novas cadeias portuárias e industriais.",
      sec2Tag: "Baía de São Marcos",
      sec2Title: "Inserção privilegiada na Baía de São Marcos",
      sec2Text:
        "Inserido em uma região de elevada relevância marítima e logística, o terminal reúne acesso estratégico e condições favoráveis para operações portuárias, apoio marítimo e integração regional.",
      sec3Tag: "Vocação",
      sec3Title: "Vocação portuária e pluralidade operacional",
      sec3Text:
        "O TUP Open Port se diferencia pela pluralidade de operações possíveis em uma mesma base: granéis, transbordo de carga, apoio logístico, bunker e cabotagem de contêineres.",
      sec4Tag: "Operadora",
      sec4Title: "O papel da OPS",
      sec4Text:
        "A Open Port Services é a operadora do TUP Open Port, com atuação institucional e operacional voltada ao desenvolvimento de uma plataforma portuária privada de múltiplas frentes.",
      capFront: "Foto frontal do terminal",
      capAerial: "Vista aérea superior do ativo",
      capSat: "Posição do terminal na região",
      capBay: "Canal de acesso e fundeadouros",
    },
    operations: {
      chip: "OPERAÇÕES",
      title: "Operações do TUP Open Port",
      sub: "Cinco frentes operacionais integradas em uma única plataforma portuária privada.",
      cta: "Solicite uma apresentação operacional",
      sections: [
        {
          tag: "Granéis",
          title: "Granéis",
          text: "No segmento de granéis, o TUP Open Port destaca operações voltadas ao Lithothamnium com a BMO, além de outras possibilidades de movimentação alinhadas à vocação operacional do terminal.",
          points: ["Movimentação de granéis", "Cadeias minerais e industriais", "Lithothamnium com a BMO"],
        },
        {
          tag: "Ship-to-Ship",
          title: "Transbordo de Carga",
          text: "Operações de transbordo (STS) entre navios, com suporte técnico-operacional e monitoramento contínuo em ambiente marítimo.",
          points: ["Operações ship-to-ship", "Suporte técnico dedicado", "Monitoramento contínuo"],
        },
        {
          tag: "Integração",
          title: "Apoio Logístico",
          text: "Apoio portuário, integração de cadeias e suporte operacional para operações marítimas e regionais.",
          points: ["Apoio portuário", "Integração de cadeias logísticas", "Suporte operacional"],
        },
        {
          tag: "Suprimento",
          title: "Bunker e Ponto de Abastecimento",
          text: "Soluções de abastecimento de combustíveis marítimos e suprimentos, reforçando o terminal como plataforma portuária e logística de múltiplas frentes.",
          points: ["Abastecimento marítimo", "Transferência de combustível", "Suporte a embarcações"],
        },
        {
          tag: "Rota Estratégica",
          title: "Cabotagem de Contêineres",
          text: "O TUP Open Port se posiciona para a cabotagem de contêineres, com destaque para a conexão São Luís – Pecém, ampliando alternativas logísticas e fortalecendo a integração entre mercados.",
          points: ["Rota São Luís – Pecém", "Transporte de contêineres", "Integração regional"],
        },
      ],
    },
    infra: {
      chip: "INFRAESTRUTURA",
      title: "Infraestrutura do TUP Open Port",
      sub: "Um ativo portuário privado com interface direta com o ambiente marítimo e capacidade de suportar múltiplas frentes operacionais.",
      block1Tag: "O Ativo",
      block1Title: "Estrutura física do terminal",
      block1Text:
        "Infraestrutura portuária privada em São Luís, com estrutura física voltada a operações marítimas e logísticas.",
      block2Tag: "Interface Marítima",
      block2Title: "Interface com o ambiente marítimo",
      block2Text:
        "Posicionado na Baía de São Marcos, o terminal combina acesso marítimo estratégico e valor de localização.",
      block3Tag: "Multi-operações",
      block3Title: "Múltiplas frentes em uma mesma base",
      block3Text:
        "A infraestrutura do TUP Open Port suporta granéis, transbordo, apoio logístico, bunker e cabotagem de contêineres.",
      aerialTitle: "Visão aérea do terminal",
      aerialSub: "Explore os pontos do ativo",
      hotspots: [
        { label: "Berço 1 S", desc: "Berço sul do cais do TUP Open Port." },
        { label: "Berço 2 N", desc: "Berço norte do cais do TUP Open Port." },
        { label: "Pátio 01 — Grãos", desc: "Pátio operacional de grãos." },
        { label: "Pátio 02 — Carga Geral", desc: "Pátio operacional de carga geral." },
        { label: "Pátio 03 — Lithothamnium", desc: "Pátio operacional de Lithothamnium." },
        { label: "Pátio 04 — BMO", desc: "Área operacional de apoio à parceria BMO." },
        { label: "Canal de Acesso", desc: "Rio dos Coqueiros — mesmo canal de acesso da Alumar." },
      ],
    },
    cabotage: {
      chip: "CABOTAGEM",
      title: "São Luís – Pecém",
      sub: "Uma frente estratégica de conectividade regional para contêineres.",
      routeOrigin: "São Luís / MA",
      routeDest: "Pecém / CE",
      routeLabel: "Rota de cabotagem de contêineres",
      items: [
        {
          title: "Conectividade regional",
          text: "Conexão marítima entre dois polos portuários estratégicos do Norte e Nordeste.",
        },
        {
          title: "Transporte de contêineres",
          text: "Cabotagem de contêineres como alternativa eficiente ao modal rodoviário de longa distância.",
        },
        {
          title: "Nova alternativa logística",
          text: "Ampliação das opções de escoamento e recebimento de cargas na região.",
        },
        {
          title: "Integração entre mercados",
          text: "Fortalecimento da integração entre mercados e cadeias produtivas regionais.",
        },
      ],
      roleTitle: "O papel do TUP Open Port",
      roleText:
        "O TUP Open Port atua como plataforma estratégica nessa rota, reunindo infraestrutura portuária privada e vocação para operações de contêineres.",
      cta: "Fale com a OPS sobre a rota",
    },
    group: {
      chip: "GRUPO",
      title: "Estrutura Empresarial",
      sub: "A Open Port Services protagoniza a operação do TUP Open Port, com suporte complementar das empresas do grupo.",
      opsTag: "Operadora do TUP Open Port",
      opsTitle: "Open Port Services (OPS)",
      opsText:
        "Operadora do TUP Open Port — Terminal de Uso Privado em São Luís, Maranhão — e protagonista institucional e operacional do empreendimento.",
      evkTag: "Empresa do grupo",
      evkTitle: "EVK Maritime / EVK Agency",
      evkText:
        "A EVK Maritime integra o ecossistema empresarial do grupo, contribuindo com viabilidade operacional offshore, apoio técnico-operacional e soluções complementares no ambiente marítimo.",
    },
    contact: {
      chip: "CONTATO",
      title: "Fale com a OPS",
      sub: "Conheça uma nova plataforma portuária privada no Maranhão. Envie sua mensagem e nossa equipe comercial retornará.",
      name: "Nome",
      company: "Empresa",
      email: "E-mail",
      phone: "Telefone (opcional)",
      service: "Serviço de interesse",
      message: "Mensagem",
      submit: "Enviar contato",
      sending: "Enviando...",
      success: "Mensagem enviada com sucesso. Nossa equipe retornará em breve.",
      error: "Não foi possível enviar. Tente novamente.",
      services: [
        "Granéis & Lithothamnium",
        "Transbordo de Carga (STS)",
        "Apoio Logístico",
        "Bunker e Abastecimento",
        "Cabotagem de Contêineres",
        "Apresentação institucional",
        "Outro",
      ],
      infoEmailTag: "E-mail comercial",
      infoAddr1Tag: "Terminal",
      infoAddr1: "Estrada do Porto Grande S/N, Vila Maranhão – Terminal do Porto Grande – São Luís/MA",
      infoAddr2Tag: "Escritório",
      infoAddr2: "Av. do Holandeses, n° 7, Ed. Metropolitan, Sala 710, Calhau – São Luís/MA",
    },
    footer: {
      tagline: "Operadora do TUP Open Port — Terminal de Uso Privado",
      navTag: "Navegação",
      contactTag: "Contato",
      groupTag: "Grupo",
      evk: "EVK Maritime — empresa do grupo OPS",
      location: "São Luís, Maranhão, Brasil • Baía de São Marcos",
      rights: "© Open Port Services. Todos os direitos reservados.",
    },
  },
  en: {
    nav: {
      home: "Home",
      terminal: "The Terminal",
      operations: "Operations",
      infrastructure: "Infrastructure",
      cabotage: "Cabotage",
      group: "Group",
      contact: "Contact",
      cta: "Talk to OPS",
    },
    home: {
      heroChip: "TUP OPEN PORT • SÃO LUÍS / MA • SÃO MARCOS BAY",
      heroTitleA: "Integrated Port Operations.",
      heroTitleB: "Strategic by Location.",
      heroSub:
        "Open Port Services presents TUP Open Port, a Private Use Terminal strategically positioned in São Luís, with a vocation for bulk cargo, ship-to-ship transshipment, logistics support, bunker, maritime supply and container cabotage.",
      heroSingular:
        "A singular terminal in its region. Strategic by location. Distinguished by operational vocation.",
      ctaTerminal: "Discover the Terminal",
      ctaOperations: "Explore Operations",
      heroCardTag: "Strategic Location",
      heroCardText: "Privileged position in São Marcos Bay, São Luís/MA.",
      heroBtn: "Request a Presentation",
      marquee: [
        "Bulk Cargo & Minerals",
        "Lithothamnium in partnership with BMO",
        "STS Cargo Transshipment",
        "São Luís – Pecém Cabotage",
        "Bunker & Supply",
        "Logistics Support",
      ],
      locTag: "Location",
      locTitle: "Strategic location in São Marcos Bay",
      locText:
        "Set in a region of high maritime and logistics relevance, TUP Open Port combines a privileged location, strategic access and favorable conditions for the development of port operations, maritime support and regional integration.",
      locCapState: "Maranhão — regional footprint",
      locCapSat: "Terminal position — aerial view",
      locCapBay: "São Marcos Bay — access channel and anchorages",
      diffTag: "Differentiators",
      diffTitle: "A differentiated terminal in its region",
      diffText:
        "TUP Open Port is one of the most strategic port developments in its area of influence, with a singular profile given by the combination of activities it brings together.",
      diffItems: [
        "Strategic location",
        "Private port infrastructure",
        "Bulk cargo",
        "Cargo transshipment",
        "Logistics support",
        "Bunker / Supply",
        "Container cabotage",
        "Integration with new regional chains",
      ],
      opsTag: "Capabilities",
      opsTitle: "OPS Operational Pillars",
      opsText: "Technical structure to serve international shipowners and production chains.",
      learnMore: "Learn more",
      opsCards: [
        {
          tag: "01 • Bulk Cargo",
          title: "Bulk Cargo",
          desc: "Solid bulk handling, highlighted by the Lithothamnium operation in partnership with BMO.",
        },
        {
          tag: "02 • Nautical Operations",
          title: "Cargo Transshipment (STS)",
          desc: "Ship-to-ship transshipment operations with technical support and continuous monitoring.",
        },
        {
          tag: "03 • Integration",
          title: "Logistics Support",
          desc: "Port support, integration and operational assistance for regional chains.",
        },
        {
          tag: "04 • Supply",
          title: "Bunker & Supply Point",
          desc: "Marine fuel supply and operational provisions.",
        },
        {
          tag: "05 • Cabotage",
          title: "Container Cabotage",
          desc: "São Luís – Pecém connection expanding regional logistics alternatives.",
        },
        {
          tag: "06 • Port Asset",
          title: "Port Infrastructure",
          desc: "Private Use Terminal prepared for multiple operational fronts.",
        },
      ],
      bmoTag: "Strategic Bulk Front",
      bmoTitle: "Bulk cargo featuring Lithothamnium",
      bmoText:
        "Within its bulk cargo vocation, TUP Open Port highlights operations related to Lithothamnium with BMO, reinforcing its capacity to serve specialized logistics chains and demands of high operational relevance.",
      bmoBoxTitle: "BMO Operational Partnership",
      bmoBoxText:
        "Capacity to serve specialized logistics chains and demands of high operational relevance, connecting bulk cargo, scale and maritime logistics.",
      bmoBadge: "Lithothamnium & BMO • TUP Open Port",
      cabTag: "Cabotage",
      cabTitle: "São Luís – Pecém",
      cabText:
        "TUP Open Port also positions itself for container cabotage, highlighting the São Luís – Pecém connection, expanding regional logistics alternatives and strengthening integration between markets.",
      cabBtn: "Discover the route",
      bunkTag: "Maritime Support",
      bunkTitle: "Bunker & Supply",
      bunkText:
        "Maritime support and supply solutions are part of TUP Open Port's operational proposal, reinforcing its positioning as a multi-front port and logistics platform.",
      bunkBtn: "Learn more",
      ctaTitle: "Your operation can start here",
      ctaText:
        "Discover a new private port platform in Maranhão, structured to integrate cargo, maritime operations, logistics support and new regional opportunities.",
      ctaBtn1: "Talk to OPS",
      ctaBtn2: "Request a presentation",
    },
    terminal: {
      chip: "THE TERMINAL",
      title: "TUP Open Port",
      sub: "A Private Use Terminal strategically positioned in São Luís, Maranhão, with privileged insertion in São Marcos Bay.",
      keyMessage: "The location of TUP Open Port is one of its main strategic assets.",
      sec1Tag: "Position",
      sec1Title: "Strategic position in São Luís",
      sec1Text:
        "The location of TUP Open Port is one of its main strategic assets, favoring maritime operations, logistics support and integration with new port and industrial chains.",
      sec2Tag: "São Marcos Bay",
      sec2Title: "Privileged insertion in São Marcos Bay",
      sec2Text:
        "Set in a region of high maritime and logistics relevance, the terminal combines strategic access and favorable conditions for port operations, maritime support and regional integration.",
      sec3Tag: "Vocation",
      sec3Title: "Port vocation and operational plurality",
      sec3Text:
        "TUP Open Port stands out for the plurality of operations possible on a single base: bulk cargo, transshipment, logistics support, bunker and container cabotage.",
      sec4Tag: "Operator",
      sec4Title: "The role of OPS",
      sec4Text:
        "Open Port Services is the operator of TUP Open Port, with institutional and operational activity aimed at developing a private, multi-front port platform.",
      capFront: "Terminal front view",
      capAerial: "Top aerial view of the asset",
      capSat: "Terminal position in the region",
      capBay: "Access channel and anchorages",
    },
    operations: {
      chip: "OPERATIONS",
      title: "TUP Open Port Operations",
      sub: "Five operational fronts integrated into a single private port platform.",
      cta: "Request an operational presentation",
      sections: [
        {
          tag: "Bulk Cargo",
          title: "Bulk Cargo",
          text: "In the bulk segment, TUP Open Port highlights operations aimed at Lithothamnium with BMO, in addition to other handling possibilities aligned with the terminal's operational vocation.",
          points: ["Bulk handling", "Mineral and industrial chains", "Lithothamnium with BMO"],
        },
        {
          tag: "Ship-to-Ship",
          title: "Cargo Transshipment",
          text: "Ship-to-ship (STS) transshipment operations, with technical-operational support and continuous monitoring in the maritime environment.",
          points: ["Ship-to-ship operations", "Dedicated technical support", "Continuous monitoring"],
        },
        {
          tag: "Integration",
          title: "Logistics Support",
          text: "Port support, chain integration and operational assistance for maritime and regional operations.",
          points: ["Port support", "Logistics chain integration", "Operational support"],
        },
        {
          tag: "Supply",
          title: "Bunker & Supply Point",
          text: "Marine fuel supply and provisions solutions, reinforcing the terminal as a multi-front port and logistics platform.",
          points: ["Maritime supply", "Fuel transfer", "Vessel support"],
        },
        {
          tag: "Strategic Route",
          title: "Container Cabotage",
          text: "TUP Open Port positions itself for container cabotage, highlighting the São Luís – Pecém connection, expanding logistics alternatives and strengthening integration between markets.",
          points: ["São Luís – Pecém route", "Container transport", "Regional integration"],
        },
      ],
    },
    infra: {
      chip: "INFRASTRUCTURE",
      title: "TUP Open Port Infrastructure",
      sub: "A private port asset with direct interface with the maritime environment and capacity to support multiple operational fronts.",
      block1Tag: "The Asset",
      block1Title: "Terminal physical structure",
      block1Text:
        "Private port infrastructure in São Luís, with a physical structure aimed at maritime and logistics operations.",
      block2Tag: "Maritime Interface",
      block2Title: "Interface with the maritime environment",
      block2Text:
        "Positioned in São Marcos Bay, the terminal combines strategic maritime access and location value.",
      block3Tag: "Multi-operations",
      block3Title: "Multiple fronts on a single base",
      block3Text:
        "TUP Open Port's infrastructure supports bulk cargo, transshipment, logistics support, bunker and container cabotage.",
      aerialTitle: "Terminal aerial view",
      aerialSub: "Explore the asset's key points",
      hotspots: [
        { label: "Berth 1 S", desc: "South berth of the TUP Open Port quay." },
        { label: "Berth 2 N", desc: "North berth of the TUP Open Port quay." },
        { label: "Yard 01 — Grain", desc: "Grain operational yard." },
        { label: "Yard 02 — General Cargo", desc: "General cargo operational yard." },
        { label: "Yard 03 — Lithothamnium", desc: "Lithothamnium operational yard." },
        { label: "Yard 04 — BMO", desc: "Operational area supporting the BMO partnership." },
        { label: "Access Channel", desc: "Rio dos Coqueiros — same access channel as Alumar." },
      ],
    },
    cabotage: {
      chip: "CABOTAGE",
      title: "São Luís – Pecém",
      sub: "A strategic front of regional connectivity for containers.",
      routeOrigin: "São Luís / MA",
      routeDest: "Pecém / CE",
      routeLabel: "Container cabotage route",
      items: [
        {
          title: "Regional connectivity",
          text: "Maritime connection between two strategic port hubs in North and Northeast Brazil.",
        },
        {
          title: "Container transport",
          text: "Container cabotage as an efficient alternative to long-distance road transport.",
        },
        {
          title: "New logistics alternative",
          text: "Expanded options for cargo outflow and intake in the region.",
        },
        {
          title: "Integration between markets",
          text: "Strengthened integration between regional markets and production chains.",
        },
      ],
      roleTitle: "The role of TUP Open Port",
      roleText:
        "TUP Open Port acts as a strategic platform on this route, combining private port infrastructure and a vocation for container operations.",
      cta: "Talk to OPS about the route",
    },
    group: {
      chip: "GROUP",
      title: "Corporate Structure",
      sub: "Open Port Services leads the operation of TUP Open Port, with complementary support from the group's companies.",
      opsTag: "TUP Open Port Operator",
      opsTitle: "Open Port Services (OPS)",
      opsText:
        "Operator of TUP Open Port — Private Use Terminal in São Luís, Maranhão — and the institutional and operational protagonist of the enterprise.",
      evkTag: "Group company",
      evkTitle: "EVK Maritime / EVK Agency",
      evkText:
        "EVK Maritime is part of the group's business ecosystem, contributing with offshore operational feasibility, technical-operational support and complementary solutions in the maritime environment.",
    },
    contact: {
      chip: "CONTACT",
      title: "Talk to OPS",
      sub: "Discover a new private port platform in Maranhão. Send your message and our commercial team will get back to you.",
      name: "Name",
      company: "Company",
      email: "E-mail",
      phone: "Phone (optional)",
      service: "Service of interest",
      message: "Message",
      submit: "Send message",
      sending: "Sending...",
      success: "Message sent successfully. Our team will get back to you soon.",
      error: "Could not send. Please try again.",
      services: [
        "Bulk Cargo & Lithothamnium",
        "Cargo Transshipment (STS)",
        "Logistics Support",
        "Bunker & Supply",
        "Container Cabotage",
        "Institutional presentation",
        "Other",
      ],
      infoEmailTag: "Commercial e-mail",
      infoAddr1Tag: "Terminal",
      infoAddr1: "Estrada do Porto Grande S/N, Vila Maranhão – Terminal do Porto Grande – São Luís/MA",
      infoAddr2Tag: "Office",
      infoAddr2: "Av. do Holandeses, n° 7, Ed. Metropolitan, Sala 710, Calhau – São Luís/MA",
    },
    footer: {
      tagline: "Operator of TUP Open Port — Private Use Terminal",
      navTag: "Navigation",
      contactTag: "Contact",
      groupTag: "Group",
      evk: "EVK Maritime — an OPS group company",
      location: "São Luís, Maranhão, Brazil • São Marcos Bay",
      rights: "© Open Port Services. All rights reserved.",
    },
  },
};
